import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import SitesTable from "../../components/sites/SitesTable";
import SitesModal from "../../components/sites/SitesModal";
import SiteLocationsModal from "../../components/sites/SiteLocationsModal";
import useSites from "../../data/useSites";
import { ISiteSummary } from "../../models/Site";

export default function Sites() {
  const { setInfo } = usePageNameContext();
  const { summaries } = useSites();
  const [editSite, setEditSite] = useState<ISiteSummary | undefined>(undefined);
  const [assignSite, setAssignSite] = useState<ISiteSummary | undefined>(undefined);
  const [editOpen, setEditOpen] = useState(false);
  const [assignOpen, setAssignOpen] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Sites",
      desc: "Manage depots and which yard and warehouse locations belong to each",
    });
  }, []);

  const handleSetSite = (site: ISiteSummary) => {
    setEditSite(site);
    setEditOpen(true);
  };

  const handleAddSite = () => {
    setEditSite(undefined);
    setEditOpen(true);
  };

  const handleAssign = (site: ISiteSummary) => {
    setAssignSite(site);
    setAssignOpen(true);
  };

  return summaries.isLoading ? (
    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
      <LoadingWheel />
    </div>
  ) : (
    <>
      <SitesModal open={editOpen} setOpen={setEditOpen} site={editSite} />
      <SiteLocationsModal open={assignOpen} setOpen={setAssignOpen} site={assignSite} />
      <div className="mt-4 flex justify-between">
        <button
          className=" bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
          type="button"
          onClick={handleAddSite}
        >
          <PlusSmallIcon className="h-5 w-5 mr-2" />
          Add New Site
        </button>
      </div>

      <SitesTable sites={summaries.data?.data ?? []} setSite={handleSetSite} setAssignSite={handleAssign} />
    </>
  );
}
